import React, { useEffect, useState } from 'react';

import dynamic from 'next/dynamic';

import { isReactNativeWebView } from '@/utils/common';

import {
  mainContainerStyle,
  safeAreaFixedOverlayStyle,
} from './appLayout.style';

// Replaced styled imports from @/mainPages/search-start.style (which imports
// @mui/system → @emotion/cache) with plain divs, removing @emotion from the
// initial bundle. Styles are equivalent to the originals.

const ToastContainer = dynamic(
  () =>
    import('react-toastify').then(async (m) => {
      await import('react-toastify/dist/ReactToastify.css');
      return { default: m.ToastContainer };
    }),
  { ssr: false }
);

const AppLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [safeTop, setSafeTop] = useState<number>(0);

  useEffect(() => {
    const top = (window as { __SAFE_TOP__?: number }).__SAFE_TOP__ ?? 0;
    if (top > 0) setSafeTop(top);
  }, []);

  return (
    <>
      {/* SafeAreaContainer — fixed overlay for native app status bar */}
      {safeTop > 0 && <div style={safeAreaFixedOverlayStyle(safeTop)} />}
      {/* MainContainer */}
      <div style={mainContainerStyle(safeTop)}>{children}</div>
      <ToastContainer
        style={
          isReactNativeWebView()
            ? {
                top: safeTop + 60,
                left: 16,
                right: 16,
                width: 'auto',
              }
            : undefined
        }
        position="top-center"
        autoClose={3000}
      />
    </>
  );
};

export default AppLayout;
